import { vTooltip } from "floating-vue";
import "floating-vue/dist/style.css";
import "@/common/assets/css/floating-vue.css";

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive("tooltip", vTooltip);
});
